// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { cilXCircle } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { CFormInput } from "@coreui/react-pro";
import debounce from "lodash.debounce";
import { useCallback, useEffect, useState } from "react";

const FreeformSegment = ({ segment, search, segmentSearch, onChange, ...props }) => {
  const [filteredSegs, setFilteredSegs] = useState([]);
  const [value, setValue] = useState("");
  const [filter, setFilter] = useState("");
  const [error, setError] = useState("");

  const [errorClass, setErrorClass] = useState("");

  useEffect(() => {
    const sname = `${segment.name}:or`;
    if (search[sname] && search[sname].length > 0) {
      setValue(search[sname][0]);
    } else {
      setValue("");
    }
  }, [search, segment]);

  const setValueDebounced = useCallback(
    debounce((text) => {
      const change = {
        replace: true,
        name: `${segment.name}:or`,
        value: segment.upperCase ? text.toUpperCase() : text,
      };
      onChange([change]);
    }, 500),
    [],
  );

  const onInnerChange = (val) => {
    setValue(val);
    if (segment.length && val.length > segment.length) {
      setError(segment.error ?? "NO_ERROR");
    } else {
      setValueDebounced(val);
      setError("");
    }
  };

  return (
    <div className={"search-segment-container d-flex"}>
      <div style={{ width: "10rem", position: "relative" }}>
        <CFormInput
          style={{ paddingRight: segment?.allowClear && !error && !!value ? "1.7rem" : 0 }}
          className={error && "is-invalid"}
          size={"sm"}
          placeholder={segment.title}
          feedbackInvalid={error}
          value={value}
          onChange={(e) => {
            onInnerChange(e.target.value);
          }}
        />
        {segment?.allowClear && !error && !!value > 0 && (
          <span
            style={{ cursor: "pointer" }}
            className={"position-absolute top-50 end-0 translate-middle"}
            color={"secondary"}
            variant={"outline"}
            onClick={() => onInnerChange("")}
          >
            <CIcon icon={cilXCircle} />
          </span>
        )}
      </div>
    </div>
  );
};

export default FreeformSegment;
